import NumberFormat, {
  type NumberFormatProps,
} from '@procurifydev/react-number-format'
import styled from 'styled-components'

export const NumberFieldStyled = styled((props: NumberFormatProps) => {
  return <NumberFormat {...props} />
})`
  text-align: left;
`
